import axios from 'axios';

let key = "MlJkqIESBePbUsVYw9tFJehKGAFON6PASL7qVkqtvliiClNANkN4CAfjZaaZ1ohZ";

var instance = axios.create({
    baseURL: 'https://app.menud.co/api/Platelists/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/Containers/LandingPage/Components/Axios/Axios.js